
<div
  class="search-area"
  ref="searchArea"
  :style="removeMargin ? { '--text-input-margin-bottom': 0 } : null"
>
  <dropdown
    flex
    align="left"
    :active="active"
    @close="active = false"
  >
    <div class="input-wrapper">
      <textarea
        v-model.trim="localValue"
        ref="input"
        rows="1"
        maxlength="10000"
        :placeholder="placeholder"
        :autocomplete="options ? 'off' : 'on'"
        @input="update"
        @keydown.enter.prevent
        @focus="handleFocus"
      />

      <span v-if="loading" class="icon-spot">
        <span class="spinner" />
      </span>

      <div v-else class="icon-spot">
        <icon-button
          size="20"
          :icon="rightIcon"
          :hidden="isRightIconHidden"
          @click="handleRightIcon"
        />
      </div>
    </div>

    <template #menu>
      <dropdown-menu
        hide-no-results
        :options="filteredOptions"
        :activeValue="value"
        @select="handleSelect"
      />
    </template>
  </dropdown>
</div>
